import React from 'react';

import DetailsPanel from 'ff/debrief/layouts/DetailsPanel';
import TracklogDetails from 'ff/debrief/components/details/TracklogDetails';

const FlightDetails = () => {
    return (
        <DetailsPanel>
            <TracklogDetails />
        </DetailsPanel>
    );
};

export default FlightDetails;
